import { MetaData } from '@xing-com/crate-lebenslauf-components';
import { Frame } from '@xing-com/crate-lebenslauf-xinglets';
import type { msw, Xinglet } from '@xing-com/crate-xinglet';

import { New } from './new';

const title = 'Lebenslauf online erstellen - mit dem Lebenslauf Editor | XING';
const description =
  'Jetzt deinen Lebenslauf online erstellen und gestalten. Und direkt als PDF runterladen. Ganz einfach mit dem XING Lebenslauf Editor!';

export default class NewXinglet implements Xinglet {
  public async registerMocks(msw: msw): Promise<void> {
    (await import('./mocks')).setupMocking(msw);
  }

  public getComponent() {
    return (): JSX.Element => {
      return (
        <Frame hideFooter noMainContentWrapperStyles isEditorPage>
          <MetaData title={title} description={description} />
          <New />
        </Frame>
      );
    };
  }
}
